import React from 'react';
import { formatPhone } from '../../utils/phone';
import { IUserBase } from '../../types/type';
import img from '../../assets/profile.png';
import { store } from '../../store/store';
import { mediaUrl, fullName } from '../../utils/utils';
import { formatBackendDateTime } from '../../utils/date.utils';

const baseURL = store.getState().config.baseURL;

function AdminList({
  sortedAndSearchedPosts,
  onUserClick,
}: {
  sortedAndSearchedPosts: Array<Record<string, any>>;
  onUserClick: (id: string, role: string) => void;
}) {
  const data = sortedAndSearchedPosts as IUserBase[];

  return (
    <React.Fragment>
      {data?.map((item: IUserBase, index: number) => (
        <React.Fragment key={item.id + index}>
          <tr className="table-row">
            <td className="user-info">
              <div className="user-image">
                <img src={mediaUrl(item.avatar, baseURL) ?? img} alt="User" />
              </div>
              <div className="user-details">
                <div className="user-name">{fullName(item)}</div>
                <div className="user-nickname">{item.username}</div>
                <div className="user-status">
                  <span className={`status-dot ${item.isActive ? 'active' : 'no_active'}`}></span>
                  {item.isActive ? 'Активен' : 'Не активен'}
                </div>
              </div>
            </td>
            <td className="user-registration">
              <div className="user-registration__date">
                Последний визит {item.loginDate && <span>{formatBackendDateTime(item.loginDate)}</span>}
              </div>
              <div className="user-registration__role">
                Роль
                <span>
                  {item.role === 'driver'
                    ? 'Водитель'
                    : item.role === 'medic'
                      ? 'Медик'
                      : item.role === 'technik'
                        ? 'Техник'
                        : item.role === 'autopark_employee'
                          ? 'Представитель автопарка'
                          : 'Админ'}
                </span>
              </div>
            </td>
            <td className="user-registration">
              <div>
                Мобильный {''}
                <span className="number">{formatPhone(item.phone)}</span>
              </div>
              <div>
                Город
                {item.address && <span className="number">{item.address}</span>}
              </div>
            </td>

            <td className="user-action">
              <div className="link-button" onClick={() => onUserClick(item.id, item.role)}>
                Смотреть
              </div>
              <svg
                className="icon__eye"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.625 7.5C0.625 7.5 3.125 2.5 7.5 2.5C11.875 2.5 14.375 7.5 14.375 7.5C14.375 7.5 11.875 12.5 7.5 12.5C3.125 12.5 0.625 7.5 0.625 7.5Z"
                  stroke="#25282B"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.5 9.375C8.53553 9.375 9.375 8.53553 9.375 7.5C9.375 6.46447 8.53553 5.625 7.5 5.625C6.46447 5.625 5.625 6.46447 5.625 7.5C5.625 8.53553 6.46447 9.375 7.5 9.375Z"
                  stroke="#25282B"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </td>
          </tr>

          <tr key={item.id + (index + 22 * 2)} className="admin-table__item-divider" />
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

export default AdminList;
